function SitemapWebflow() {}
export async function getServerSideProps({ res }: any) {
  const request = await fetch('https://awning-com.webflow.io/sitemap.xml');
  let sitemapWebflowXML = await request.text();
  sitemapWebflowXML = sitemapWebflowXML.replaceAll('website.awning.com', 'awning.com');

  res.setHeader('Content-Type', 'application/xml');
  res.write(sitemapWebflowXML);
  res.end();

  return { props: {} };
}

export default SitemapWebflow;
